function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.041 0a4.12 4.12 0 012.891 1.209l.161.17a4.12 4.12 0 011.049 2.753v1.963h2.546c.172 0 .312.14.312.311V17.69c0 .172-.14.311-.312.311H.312A.311.311 0 010 17.69V6.405c0-.171.14-.31.312-.31h2.546V4.274a4.364 4.364 0 011.3-3.08A4.08 4.08 0 017.041 0zm6.336 6.715H.623v10.671h12.754V6.716zM7 8.386c.62 0 1.211.253 1.64.698a2.45 2.45 0 01-.233 3.598v1.698a1.41 1.41 0 01-2.11 1.215 1.403 1.403 0 01-.704-1.215v-1.698a2.453 2.453 0 01-.233-3.588A2.274 2.274 0 017 8.386zm-.001.617a1.64 1.64 0 00-1.196.517c-.325.34-.504.792-.5 1.262a1.789 1.789 0 00.776 1.49.313.313 0 01.138.254v1.962a.783.783 0 001.192.617.783.783 0 00.374-.725v-1.852a.315.315 0 01.134-.255 1.66 1.66 0 00.278-.23 1.843 1.843 0 000-2.523A1.642 1.642 0 007 9.003zm.034-8.39H7a3.418 3.418 0 00-2.405 1.023 3.743 3.743 0 00-1.116 2.639v1.814h7.04V4.126A3.51 3.51 0 007.032.614z"
});

var SvgPrivacy = function SvgPrivacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/privacy.7870e900.svg";
export { SvgPrivacy as ReactComponent };